module.exports = __webpack_public_path__ + "assets/icon-list-x-component.fd8b35fa.svg";